export default "__VITE_ASSET__C8lb1A$D__"